/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { MSTGQLRef, QueryBuilder, withTypedRefs } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RouteDtoModel, RouteDtoModelType } from "./RouteDtoModel"
import { RouteDtoModelSelector } from "./RouteDtoModel.base"
import { RootStoreType } from "./index"


/* The TypeScript type that explicits the refs to other models in order to prevent a circular refs issue */
type Refs = {
  route: RouteDtoModelType;
}

/**
 * RouteStopUnscheduledDtoBase
 * auto generated base class for the model RouteStopUnscheduledDtoModel.
 *
 * Route unscheduled event
 */
export const RouteStopUnscheduledDtoModelBase = withTypedRefs<Refs>()(ModelBase
  .named('RouteStopUnscheduledDto')
  .props({
    __typename: types.optional(types.literal("RouteStopUnscheduledDto"), "RouteStopUnscheduledDto"),
    /** Payload of route unscheduled */
    route: types.union(types.undefined, MSTGQLRef(types.late((): any => RouteDtoModel))),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  })))

export class RouteStopUnscheduledDtoModelSelector extends QueryBuilder {
  route(builder: string | RouteDtoModelSelector | ((selector: RouteDtoModelSelector) => RouteDtoModelSelector) | undefined) { return this.__child(`route`, RouteDtoModelSelector, builder) }
}
export function selectFromRouteStopUnscheduledDto() {
  return new RouteStopUnscheduledDtoModelSelector()
}

export const routeStopUnscheduledDtoModelPrimitives = selectFromRouteStopUnscheduledDto()
